import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';
import { Col, Row, Typography, Form, FormInstance } from 'antd';
import { SupplierListItemType } from '@institutions/graphql';
import { ContentContainer, TextArea } from '@common/components';

const { Title } = Typography;

export function SuppliersManagementInvitationStepReview({
  suppliers = [],
  form,
}: {
  suppliers: SupplierListItemType[];
  form: FormInstance;
}) {
  const plural = suppliers.length > 1 ? 's' : '';
  const title = `Invite${plural} Summary`;

  return (
    <>
      <div className="supplier-invitation-review">
        <ContentContainer title={title}>
          <div className="supplier-invitation-review-data-section">
            <Form form={form}>
              {suppliers.map((supplier, i) => (
                <div key={supplier.id}>
                  <Title level={2}>{`${i + 1}. ${supplier.name}`}</Title>
                  <Row gutter={24}>
                    <Col span={4}>Main Contact</Col>
                    <Col span={20}>
                      {supplier?.defaultContact?.name || 'N/A'}
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={4}>Notes</Col>
                    <Col span={12}>
                      <Form.Item name={supplier.id}>
                        <TextArea
                          maxLength={600}
                          placeholder="Add a note for this supplier"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              ))}
            </Form>
          </div>
        </ContentContainer>
      </div>
      <style jsx>{`
        .supplier-invitation-review-data-section
          :global(.ant-row .ant-col:first-child) {
          color: ${Colors.midnightLighter};
          font-weight: 200;
          margin-bottom: 4px;
        }
      `}</style>
    </>
  );
}
